import React from 'react'
import { func, string, node, oneOfType } from 'prop-types'
import classNames from 'classnames'

const CardContent = ({
  children,
  className: classNameProp,
  component: Component,
  ...other
}) => {
  const className = classNames(
    'campus-card-content',
    classNameProp
  )

  return (
    <div className={className} {...other}>
      {children}
      <style jsx>
        {`
          .campus-card-content {
            padding-top: 1rem;
            padding-bottom: 1rem;
          }
        `}
      </style>
    </div>
  )
}

CardContent.propTypes = {
  className: string,
  children: node,
  component: oneOfType([
    string,
    func,
  ]),
}

CardContent.defaultProps = {
  component: 'div',
}

export default CardContent
